import {
  AddToCalendarIcon,
  DeleteIcon,
  EditIcon,
  MoveIcon,
  ResourceMenuActions,
  type ResourceMenuItem,
} from '@all-manager/design-system-v2';
import type { EventDatabse } from '../../../../../types';
import CreateUpdateEventModal from '../../../../events/external-components/CreateUpdateEventModal/CreateUpdateEventModal';
import DeleteEventModal from '../../../../events/external-components/DeleteEventModal/DeleteEventModal';
import MoveHistoryItemModal from '../../Historic/MoveHistoryItemModal';
import { useEventMenuActions } from './useEventMenuActions';

type Props = {
  event: EventDatabse;
};

export default function EventMenuActions(props: Props) {
  const hook = useEventMenuActions(props);

  const actions: (ResourceMenuItem | null | undefined | false)[] = [
    Boolean(props.event.date && props.event.title) && {
      id: 'google-calendar',
      label: 'Ajouter à mon agenda Google',
      icon: <AddToCalendarIcon fontSize="small" />,
      onClick: hook.handleAddToGoogleCalendar,
    },
    hook.isAdmin && {
      id: 'edit',
      label: 'Modifier',
      icon: <EditIcon fontSize="small" />,
      onClick: hook.handleUpdateClick,
    },
    hook.isAdmin && {
      id: 'move',
      label: 'Déplacer',
      icon: <MoveIcon fontSize="small" />,
      onClick: hook.handleMoveClick,
    },
    hook.isAdmin && { type: 'divider', id: 'divider' },
    hook.isAdmin && {
      id: 'delete',
      label: 'Supprimer',
      icon: <DeleteIcon fontSize="small" color="error" />,
      onClick: hook.handleDeleteClick,
    },
  ];

  return (
    <>
      <ResourceMenuActions actions={actions} tooltip={`Options du rendez-vous ${props.event.title ?? ''}`.trim()} />

      {hook.activeModal === 'update' && props.event.id && props.event.subject_id ? (
        <CreateUpdateEventModal
          eventId={props.event.id}
          subTopicId={props.event.subject_id}
          onClose={hook.handleModalClose}
        />
      ) : null}

      {hook.activeModal === 'delete' ? (
        <DeleteEventModal
          event={props.event}
          onClose={hook.handleModalClose}
        />
      ) : null}

      {hook.activeModal === 'move' ? (
        <MoveHistoryItemModal
          item={hook.historyItem}
          onClose={hook.handleModalClose}
        />
      ) : null}
    </>
  );
}

export { EventMenuActions };

